import useSWR from 'swr';
import { DGetComplaintConversation } from '../data/dtos/conversation';
import { complaintChatService } from '../services/complaint';

export function useComplaintConversation({
  userId,
}: Nullable<DGetComplaintConversation>) {
  const execute = async () => {
    return await complaintChatService.getUserConversation({
      userId: userId!,
    });
  };

  const fetchKey = userId ? ['get-complaint-conversation', userId] : null;
  const { mutate, data, isLoading, error } = useSWR(fetchKey, execute);

  return {
    mutate,
    data,
    error,
    isLoading,
  };
}
